import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { CompanyCmsComponents } from '@core/const';
import { SdvorButtonComponent, SdvorInputAutocompleteComponent } from '@sdvor/shared/ui';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { SdAddCompanyComponent } from './add-company.component';

@NgModule({
  imports: [
    AsyncPipe,
    NgIf,
    SdvorInputAutocompleteComponent,
    SdvorButtonComponent,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [CompanyCmsComponents.AddCompanyComponent]: {
          component: SdAddCompanyComponent,
        },
      },
    }),
  ],
  declarations: [SdAddCompanyComponent],
  exports: [SdAddCompanyComponent],
})
export class SdAddCompanyModule {}
